(function () {
    const timepickers = document.querySelectorAll('.timepicker')
    timepickers.forEach(async (picker, i) => {
        const {TimePicker} = await import(/* webpackChunkName: "timepickerFactory" */'./Timepicker')
        new TimePicker(picker)
    })
})()